import { createContext, useState, useMemo } from 'react'
import { node } from 'prop-types'
import { api } from 'api'

export const patternContext = createContext({})

export const PatternProvider = ({ children }) => {
  const [byId, setById] = useState({})
  const [patternsLoading, setPatternsLoading] = useState(true)

  const fetchPatterns = useMemo(
    () => () =>
      api.get('/api/v1/account/field/patterns-summary').then(({ data }) => {
        setById(prev => data.reduce((acc, row) => ({ ...acc, [row.id]: row }), prev))
        setPatternsLoading(false)
        return data
      }),
    [],
  )

  const updatePatterns = newPatterns => {
    setById(newPatterns)
  }

  const value = useMemo(
    () => ({
      byId,
      fetchPatterns,
      updatePatterns,
      patternsLoading,
    }),
    [byId, fetchPatterns, updatePatterns, patternsLoading],
  )

  return <patternContext.Provider value={value}>{children}</patternContext.Provider>
}

PatternProvider.propTypes = {
  children: node.isRequired,
}
